/** Merged Indonesian Near Me copy (flagship wave 1 + wave 2). */
import { NEAR_ID_COPY, type NearIdCopy } from "./id-copy";
import { NEAR_ID2_COPY } from "./id-copy-2";
import type { NearIdAnyKey } from "./id-keys";

export const NEAR_ID_ALL_COPY: Record<NearIdAnyKey, NearIdCopy> = {
  ...NEAR_ID_COPY,
  ...NEAR_ID2_COPY,
};
